<template>
  <!-- 小码王风格菜单 -->
  <header>
    <div :class="['menu-bar']">
      <a-row type="flex" justify="space-between">
        <a-col :span="4">
          <div class="logo">
            <a href="https://www.houcode.com" target="_blank"><img src="/img/logo-white.png" alt="" /></a>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="help-center">
            <span>帮助中心</span>
          </div>
          <div class="login-btn-wrap">
            <a-menu mode="horizontal" class="user-menu">
              <a-sub-menu key="create">
                <span slot="title" class="submenu-title-wrapper">
                  <router-link to="/center/studentCenter">
                    <a-avatar
                      style="backgroundcolor: #87d068"
                      icon="user"
                      :src="userInfo.avatarUrl || '/img/avatar.png'"
                    />
                    {{ userInfo.realname }}
                  </router-link>
                </span>
                <a-menu-item key="center:student">
                  <router-link to="/center/studentCenter">
                    个人中心
                  </router-link>
                </a-menu-item>
                <a-menu-item key="center:logout">
                  <a @click="handleLogout" target="_blank">退出登录</a>
                </a-menu-item>
              </a-sub-menu>
            </a-menu>
          </div>
          <div class="login-btn-wrap">
            <span>去上课</span>
          </div>
        </a-col>
      </a-row>
    </div>
  </header>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Menu",
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      showLogin: false,
      showRegister: false,
      userInfo: {},
      showMenu: true,
    };
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    console.log("用户信息：");
    console.log(this.userInfo);
    //需要登陆的页面
    let role = 'student'
    if(document.location.pathname.indexOf("/teacher") == 0){
      this.role = 'teacher'
    }
    document.addEventListener("tokenInvaild", function (e) {
        that.$router.push({
        path: `/user/login?role=${role}`,
      });
    });
  },
  methods: {
    ...mapActions(["Logout"]),
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({ path: "/user/login" });
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.menu-bar {
  width: 100%;
  padding: 9px 10%;
  background-color: #448af0e6;
  transition: all 0.1s ease;
  // position: fixed;

  .logo {
    img {
      height: 50px;
    }
  }
  .menu {
    background: transparent;
    border-bottom: unset;
    .ant-menu-submenu,
    .ant-menu-item > a {
      font-size: 20px;
      font-weight: 700;
      color: white !important;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      // border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .help-center {
  }
  .user-menu {
    background: transparent;
    border-bottom: unset;
    font-size: 18px;
    span {
      a {
        color: white;
      }
      .ant-avatar {
        font-size: 20px;
      }
    }
  }
  .login-btn-wrap {
    .ant-avatar {
      margin-right: 5px;
    }
    span {
      color: white;
    }
  }
}
</style>